const defaultFormTypeState = {
  showFilesPopup: false,
  files: [],
  showAddPopup: false,
  isCreating: false,
  isDeleting: false,
};

const formTypeReducer = (state = defaultFormTypeState, action) => {
  switch (action.type) {
    case 'FORMTYPE_FILES_MODAL_SHOW':
      return {
        ...state,
        showFilesPopup: true,
        files: action.files,
      };
    case 'FORMTYPE_CREATE_START':
      return {
        ...state,
        isCreating: action.formId,
      };
    case 'FORMTYPE_CREATE_END':
      return {
        ...state,
        isCreating: false,
      };
    case 'FORMTYPE_DELETE_START':
      return {
        ...state,
        isDeleting: true,
      };
    case 'SET_USER_DETAILS': // This happens when we successfully complete deleting a form
    case 'FORMTYPE_DELETE_END':
      return {
        ...state,
        isDeleting: false,
      };
    case 'FORMTYPE_FILES_MODAL_HIDE':
      return {
        ...state,
        showFilesPopup: false,
        files: [],
      };
    case 'FORMTYPE_ADD_MODAL_SHOW':
      return {
        ...state,
        showAddPopup: true,
      };
    case 'FORMTYPE_ADD_MODAL_HIDE':
      return {
        ...state,
        showAddPopup: false,
      };
    default:
      return state;
  }
};

export default formTypeReducer;
